const templates =  {
    "shop.okraina.ru": {
        title: "Моя корзина",
        tags: [
            {
                name: "description",
                content: "",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
    "dostavka.okraina.ru": {
        title: "Моя корзина",
        tags: [
            {
                name: "description",
                content: "",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
}

export default templates;